import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=14a181ad&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=14a181ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a181ad",
  null
  
)

export default component.exports